import React, { useEffect, useRef, useState } from 'react'
import './Mobileuser.css'
import back from "../../imgs/backexam.png";
import milkcan from "../../imgs/milkcan.png";
import farmer from "../../imgs/farmer.png";
import khadya from "../../imgs/khadya.png";
import cash from "../../imgs/cash.png";
import time from "../../imgs/time.png";
import weight from "../../imgs/wightmachine.png";
import kendra from "../../imgs/center.png";

import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { UilEditAlt, UilTrash, UilSetting } from '@iconscout/react-unicons'
import { useLocation, useNavigate } from "react-router-dom";
import Globalcontext from '../../Context/Globalcontext';
import { useTranslation } from 'react-i18next';
import NotoSansKannada from "../../Fonts/NotoSansKannada.ttf";

const Mobileuser = (props) => {
    const { t, i18n } = useTranslation();

    const inputRefs = useRef([]);
    const [newedit, setNewedit] = useState("new");
    const [input, setInput] = useState({ sr: "", name: "", address: "-", mobno: "-", password: "Auto", usertype: "", mhsnf: "9.0", gaysnf: "8.5" });
    const [DataSource, setDataSource] = useState([]);
    const [DataSourcekendra, setDataSourcekendra] = useState([]);
    const [tableFilter, setTableFilter] = useState([]);
    const [khnames, setKhnames] = useState([]);
    const [selectedCenters, setSelectedCenters] = useState([]);

    const [value, setValue] = useState('');
    const notify = (msg) => toast(msg);
    const notifyerror = (msg) => toast.error(msg);
    const [stock, setStock] = useState();
    const [sredit, setSredit] = useState('');

    const [literauto, setLiterauto] = useState('Off');
    const [fatauto, setFatauto] = useState('Off');

    const [sanknew, setSanknew] = useState('On');
    const [sankedit, setSankedit] = useState('On');
    const [sankdelete, setSankdelete] = useState('Off');

    const [khsalenew, setkhSalenew] = useState('On');
    const [khsaleedit, setKhsaleedit] = useState('Off');
    const [khsaledelete, setKhsaledelete] = useState('Off');

    const [advnew, setAdvnew] = useState('On');
    const [advedit, setAdvedit] = useState('Off');
    const [advdelete, setAdvdelete] = useState('Off');

    const [ratibnew, setRatibnew] = useState('On');
    const [ratibedit, setRatibedit] = useState('Off');
    const [ratibdelete, setRatibdelete] = useState('Off');

    const [morningFrom, setMorningFrom] = useState('05:00');
    const [morningTo, setMorningTo] = useState('12:00');
    const [eveningFrom, setEveningFrom] = useState('17:00');
    const [eveningTo, setEveningTo] = useState('23:00');

    const [autosnf, setAutosnf] = useState('On');
    const [summ, setSumm] = useState('On');
    const [ekun, setEkun] = useState('On');
    const [prevedit, setPrevedit] = useState('Off');

    const lang = i18n?.language || localStorage.getItem("i18nextLng") || "mr";
    const isKannada = (lang || "").toLowerCase().startsWith("kn");

    useEffect(() => {
        const styleId = "mobileuser-kannada-font-style";
        if (!document.getElementById(styleId)) {
            const style = document.createElement("style");
            style.id = styleId;
            style.innerHTML = `
        @font-face {
          font-family: 'NotoSansKannadaCustom';
          src: url(${NotoSansKannada}) format('truetype');
          font-weight: normal;
          font-style: normal;
        }
      `;
            document.head.appendChild(style);
        }
    }, []);

    const fontStyle = {
        fontFamily: isKannada ? "NotoSansKannadaCustom, sans-serif" : undefined,
    };

    const handleTimeChange = (setter) => (event) => {
        setter(event.target.value);
    };

    const convertTo12Hour = (time) => {
        if (!time) return '';
        let [hours, minutes] = time.split(':');
        const period = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12;
        return `${hours}:${minutes} ${period}`;
    };

    function handleEnterKey(event, currentIndex) {
        if (event.key === 'Enter' || event.key === "Tab") {
            event.preventDefault();
            let nextIndex = null;
            nextIndex = currentIndex + 1;
            if (inputRefs.current[nextIndex]) {
                inputRefs.current[nextIndex].focus();
            }
        }
        if (event.key === 'Backspace' && (
            (event.target.tagName === 'INPUT' && event.target.value === '') ||
            (event.target.tagName === 'SELECT' && (
                (event.target.name === 'type' && event.target.value === 'प्रकार निवडा')
            ))
        )) {
            event.preventDefault();

            let prevIndex = currentIndex - 1;
            while (prevIndex >= 0) {
                const prevElement = inputRefs.current[prevIndex];
                if (prevElement) {
                    if (
                        (prevElement.tagName === 'INPUT' || prevElement.tagName === 'SELECT') &&
                        prevElement !== event.target
                    ) {
                        prevElement.focus();
                        break;
                    } else {
                        prevIndex--;
                    }
                } else {
                    prevIndex--;
                }
            }
        }
    }

    const handleChange = async (event) => {
        const name = event.target.name;
        let valuecurrent = "";
        valuecurrent = event.target.value;
        setInput(value => ({ ...value, [name]: valuecurrent }));
    }

    useEffect(() => {
        if (input.kno === "") {
            setInput(prevInput => ({
                ...prevInput,
                kno: "",
                name: "",
                type: "",
                amt: "",
                amt: "",
                remark: "",
                mhcomm: "",
                gaycomm: "",
            }))
            setNewedit("new");
        }
        else {
            let custlisttemp = JSON.parse(localStorage.getItem("custlist"));
            for (let i = 0; i < custlisttemp.length; i++) {
                setInput(prevInput => ({
                    ...prevInput,
                    name: ''
                }));
                const user = custlisttemp[i];
                if (user.kno === input.kno) {
                    setInput(prevInput => ({
                        ...prevInput,
                        name: user.cname
                    }));
                    break;
                }
            }
        }
    }, [input.kno])

    async function getmaxno() {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        props.setProgress(30);
        setTimeout(() => {
            props.setProgress(50);
        }, 200);
        axios.post('https://excellentdairy.com/dairy/php/cust/getmaxnomobileuser.php', { mainuser: localStorage.getItem("contact"), mainuser2: mainuser2 }).then(function sample(response) {
            if (response.data) {
                setInput(prevInput => ({
                    ...prevInput,
                    sr: parseInt(response.data) + 1
                }));
            }
            else {
                setInput(prevInput => ({
                    ...prevInput,
                    sr: 1
                }));
            }
        }).catch(err => {
            console.log(err);
        });
    }

    function handleEnterKeybutton(event, currentIndex) {
        if (event.key === 'Enter') {
            event.preventDefault();
            saveratib();
            let nextIndex = null;
            if (currentIndex === 0) {
                if (input.name !== "") {
                    nextIndex = currentIndex + 1;
                }
                else {
                    nextIndex = currentIndex;
                }
            }
            else {
                nextIndex = currentIndex + 1;
            }
            if (inputRefs.current[nextIndex]) {
                inputRefs.current[nextIndex].focus();
            }
        }
        else if (event.key === "Backspace") {
            if (event.target.tagName === "BUTTON") {
                if (inputRefs.current[4]) {
                    inputRefs.current[4].focus();
                }
            }
        }
    }

    const saveratib = () => {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        if (input.sr === "" || input.name === "" || input.address === "" || (input.mobno === "")) {
            notifyerror(t("mobileuser.messages.incompleteEntry"));
            return;
        }
        let rawData = {
            sr: input.sr,
            name: input.name,
            address: input.address,
            mobno: input.mobno,
            password: input.password,
            usertype: input.usertype,
            sanknew: sanknew,
            sankedit: sankedit,
            sankdelete: sankdelete,
            khsalenew: khsalenew,
            khsaleedit: khsaleedit,
            khsaledelete: khsaledelete,
            advnew: advnew,
            advedit: advedit,
            advdelete: advdelete,
            ratibnew: ratibnew,
            ratibedit: ratibedit,
            ratibdelete: ratibdelete,
            morningFrom: morningFrom,
            morningTo: morningTo,
            eveningFrom: eveningFrom,
            eveningTo: eveningTo,
            weight: literauto,
            fat: fatauto,
            autosnf: autosnf,
            ekun: ekun,
            prevedit: prevedit,
            mhsnf: input.mhsnf,
            gaysnf: input.gaysnf,
            flag: newedit,
            sredit: sredit,
            centers: JSON.stringify(selectedCenters, null, 2),
            mainuser: localStorage.getItem("contact"),
            mainuser2: mainuser2,
        }
        rawData = JSON.stringify(rawData)
        let formData = new FormData()
        if (newedit === "edit") {
            formData.append('data', rawData)
        }
        else if (newedit === "new") {
            formData.append('data', rawData)
        }
        axios.post('https://excellentdairy.com/dairy/php/cust/savemobileuser5.php', formData, {
            'Content-Type': 'multipart/form-data',
        }).then(function sample(response) {
            if (newedit === "new") {
                if (response.data.trim() === "Saved.") {
                    notify(t("mobileuser.messages.saved"));
                    setInput(prevInput => ({
                        ...prevInput,
                        sr: parseInt(input.sr) + 1,
                        name: "",
                        address: "-",
                        mobno: "-",
                        usertype: ""
                    }))
                    setSredit("");
                    setNewedit("new");
                    getsangh();
                    if (inputRefs.current[0]) {
                        inputRefs.current[0].focus();
                    }
                }
            }
            else {
                if (response.data.trim() === "updated.") {
                    notify(t("mobileuser.messages.updated"))
                    setInput(prevInput => ({
                        ...prevInput,
                        sr: parseInt(input.sr) + 1,
                        name: "",
                        address: "-",
                        mobno: "-",
                        usertype: ""
                    }))
                    setSredit("");
                    setNewedit("new");
                    getsangh();
                    if (inputRefs.current[0]) {
                        inputRefs.current[0].focus();
                    }
                }
            }
        }).catch(err => {
            console.log(err);
        });
    }

    useEffect(() => {
        getmaxno();
        getsangh();
        if (inputRefs.current[0]) {
            inputRefs.current[0].focus();
        }
    }, [])

    async function getkendralist() {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        props.setProgress(30);
        setTimeout(() => {
            props.setProgress(50);
        }, 200);
        axios.post('https://excellentdairy.com/dairy/php/cust/getkendra2.php', { mainuser: localStorage.getItem("contactplant"), mainuser2: mainuser2 }).then(function sample(response) {
            if (response.data) {
                setDataSourcekendra(response.data);
                setTimeout(() => {
                    props.setProgress(100);
                }, 200);
            }
        }).catch(err => {
            console.log(err);
        });
    }

    async function getsangh() {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        axios.post('https://excellentdairy.com/dairy/php/cust/getmobileusers.php', { mainuser: localStorage.getItem("contact"), mainuser2: mainuser2 }).then(function sample(response) {
            if (response.data) {
                setDataSource(response.data);
                setTimeout(() => {
                    props.setProgress(100);
                }, 200);
                getkendralist();
            }
        }).catch(err => {
            console.log(err);
        });
    }

    const handleTogglekendra = (cityRaw, srRaw) => {
        const city = cityRaw.trim();
        const sr = srRaw.trim();

        setSelectedCenters(prev => {
            const exists = prev.some(obj => obj.sr === sr);
            if (exists) {
                return prev.filter(obj => obj.sr !== sr);
            } else {
                return [...prev, { center: city, sr }];
            }
        });
    };

    const handleToggle = () => {
        setLiterauto(literauto === 'On' ? 'Off' : 'On');
    };

    const handleToggleekun = () => {
        setEkun(ekun === 'On' ? 'Off' : 'On');
    };

    const handleTogglefat = () => {
        setFatauto(fatauto === 'On' ? 'Off' : 'On');
    };

    const handleTogglesanknew = () => {
        setSanknew(sanknew === 'On' ? 'Off' : 'On');
    };
    const handleTogglesankedit = () => {
        setSankedit(sankedit === 'On' ? 'Off' : 'On');
    };
    const handleTogglesankdelete = () => {
        setSankdelete(sankdelete === 'On' ? 'Off' : 'On');
    };

    const handleTogglekhsalenew = () => {
        setkhSalenew(khsalenew === 'On' ? 'Off' : 'On');
    };
    const handleTogglekhsaleedit = () => {
        setKhsaleedit(khsaleedit === 'On' ? 'Off' : 'On');
    };
    const handleTogglekhsaledelete = () => {
        setKhsaledelete(khsaledelete === 'On' ? 'Off' : 'On');
    };

    const handleToggleadvnew = () => {
        setAdvnew(advnew === 'On' ? 'Off' : 'On');
    };
    const handleToggleadvedit = () => {
        setAdvedit(advedit === 'On' ? 'Off' : 'On');
    };
    const handleToggleadvdelete = () => {
        setAdvdelete(advdelete === 'On' ? 'Off' : 'On');
    };

    const handleToggleratibnew = () => {
        setRatibnew(ratibnew === 'On' ? 'Off' : 'On');
    };
    const handleToggleratibedit = () => {
        setRatibedit(ratibedit === 'On' ? 'Off' : 'On');
    };
    const handleToggleratibdelete = () => {
        setRatibdelete(ratibdelete === 'On' ? 'Off' : 'On');
    };

    const handleToggleautosnf = () => {
        setAutosnf(autosnf === 'On' ? 'Off' : 'On');
    };

    const handleToggleprev = () => {
        setPrevedit(prevedit === 'On' ? 'Off' : 'On');
    };

    const handleedit = (sr, name, address, mobno, password, usertype, weight, fat, sanknew, sankedit, sankdelete, khsalenew, khsaleedit, khsaledelete, advnew, advedit, advdelete, ratibnew, ratibedit, ratibdelete, morningFrom, morningTo, eveningFrom, eveningTo, autosnf, mhsnf, gaysnf, summ, ekun, prevedit, centers) => {
        setInput(prevInput => ({
            ...prevInput,
            sr: sr, name: name, address: address, mobno: mobno, password: password, usertype: usertype, mhsnf: mhsnf, gaysnf: gaysnf, prevedit: prevedit
        }));

        try {
            if (centers !== "null") {
                const parsed = JSON.parse(centers);
                setSelectedCenters(parsed);
            }
            else {
                setSelectedCenters([]);
            }
        } catch (err) {
            console.error('Invalid JSON from server', err);
            setSelectedCenters([]);
        }

        setLiterauto(weight);
        setFatauto(fat);

        setSanknew(sanknew);
        setSankedit(sankedit);
        setSankdelete(sankdelete);

        setkhSalenew(khsalenew);
        setKhsaleedit(khsaleedit);
        setKhsaledelete(khsaledelete);

        setAdvnew(advnew);
        setAdvedit(advedit);
        setAdvdelete(advdelete);

        setRatibnew(ratibnew);
        setRatibedit(ratibedit);
        setRatibdelete(ratibdelete);

        setMorningFrom(morningFrom);
        setMorningTo(morningTo);
        setEveningFrom(eveningFrom);
        setEveningTo(eveningTo);

        setAutosnf(autosnf);
        setSumm(summ);
        setEkun(ekun);
        setPrevedit(prevedit);

        setNewedit("edit");
        setSredit(sr);
    }

    var jsEncode = {
        encode: function (s, k) {
            var enc = "";
            var str = s.toString();
            for (var i = 0; i < str.length; i++) {
                var a = str.charCodeAt(i);
                var b = a ^ k;
                enc = enc + String.fromCharCode(b);
            }
            return enc;
        }
    };

    return (
        <div className="khadyamain" style={fontStyle}>
            <div className="firstrowkhadya">
                <img onClick={props.visibility} className='back' src={back} alt="" />
                <div className="colmainkhadya">
                    <div className="firstrow2">
                        <div className="rowsank">
                            <div className="mb-2">
                                <span className='subheadsank' style={fontStyle}>{t("mobileuser.title")}</span>
                                <input disabled onKeyDown={e => handleEnterKey(e, 1)} ref={ref => (inputRefs.current[1] = ref)} type="number" className={newedit === "new" ? "form-control inputfontkh" : "form-control inputfontkh editmode"} autoComplete='off' id="sr" name="sr" value={input.sr} onChange={handleChange} style={fontStyle}></input>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='linekh' />
            <div className="row1kh"></div>

            <div className="row1mobile">
                <div className="mb-2">
                    <span className='subheadsank' style={fontStyle}>{t("mobileuser.labels.userName")}</span>
                    <input type="text" onKeyDown={e => handleEnterKey(e, 0)} ref={ref => (inputRefs.current[0] = ref)} className={newedit === "new" ? "form-control inputfontkhlarge" : "form-control inputfontkhlarge editmode"} autoComplete='off' id="name" name="name" value={input.name} onChange={handleChange} style={fontStyle}></input>
                </div>

                <div className="mb-2">
                    <span className='subheadsank' style={fontStyle}>{t("mobileuser.labels.userType")}</span>
                    <select onKeyDown={e => handleEnterKey(e, 1)} ref={ref => (inputRefs.current[1] = ref)} list="encodings" autoComplete='off' className={newedit === "new" ? "form-control inputfont" : "form-control inputfont editmode"} id="usertypemb" name="usertype" value={input.usertype} onChange={handleChange} style={fontStyle}>
                        <option key={0} value="प्रकार निवडा">{t("mobileuser.common.selectType")}</option>
                        <option key={1} value="Regular">{t("mobileuser.common.regular")}</option>
                        <option key={2} value="Owner">{t("mobileuser.common.owner")}</option>
                    </select>
                </div>

                <div hidden className="mb-2">
                    <span className='subheadsank' style={fontStyle}>{t("mobileuser.labels.mobile")}</span>
                    <input type="text" className={newedit === "new" ? "form-control inputfontkhlarge" : "form-control inputfontkhlarge editmode"} autoComplete='off' id="mobno" name="mobno" value={input.mobno} onChange={handleChange} style={fontStyle}></input>
                </div>

                <div hidden className="mb-2">
                    <span className='subheadsank' style={fontStyle}>{t("mobileuser.labels.address")}</span>
                    <input type="text" className={newedit === "new" ? "form-control inputfontkhlarge" : "form-control inputfontkhlarge editmode"} autoComplete='off' id="address" name="address" value={input.address} onChange={handleChange} style={fontStyle}></input>
                </div>

                <div className="mb-2">
                    <span className='subheadsank' style={fontStyle}>{t("mobileuser.labels.password")}</span>
                    <input type="text" disabled={newedit === 'new' ? false : false} onKeyDown={e => handleEnterKey(e, 2)} ref={ref => (inputRefs.current[2] = ref)} className={newedit === "new" ? "form-control inputfontkhlarge" : "form-control inputfontkhlarge editmode"} autoComplete='off' id="password" name="password" value={input.password} onChange={handleChange} style={fontStyle}></input>
                </div>
            </div>

            <div className='linekh' />

            <div className="row1kh">
                <div className="mb-2">
                    <button onClick={saveratib} onKeyDown={e => handleEnterKeybutton(e, 0)} ref={ref => (inputRefs.current[3] = ref)} type="submit" className="btn btn-primary mx-1 sanksmall" style={fontStyle}>
                        {newedit === "new" ? t("mobileuser.buttons.save") : t("mobileuser.buttons.update")}
                    </button>
                    <button type="submit" className="btn btn-primary mx-1 sanksmall" style={fontStyle}>{t("mobileuser.buttons.report")}</button>
                </div>
            </div>

            <div className="rowsettings">
                <div className="containermobileuser">
                    <table id="myTablemobileuser" className="table table-bordered" style={fontStyle}>
                        <thead>
                            <tr>
                                <th className='thsmall' scope="col">{t("mobileuser.table.id")}</th>
                                <th className='thsmall' scope="col">{t("mobileuser.table.userName")}</th>
                                <th className='thsmall' scope="col">{t("mobileuser.table.userType")}</th>
                                <th className='thsmall' scope="col">{t("mobileuser.table.password")}</th>
                                <th className='thsmall' scope="col">{t("mobileuser.table.action")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {value.length > 0 ? tableFilter.map((user, index) =>
                                <tr key={index}>
                                    <td className='thsmall'>{user.kno}</td>
                                    <td className='thsmall'>{user.name}</td>
                                    <td className='thsmall'>{user.usertype}</td>
                                    <td className='thsmall'>{user.password}</td>
                                </tr>
                            )
                                :
                                DataSource.map((user, index) =>
                                    <tr key={index}>
                                        <td className='thsmall'>{user.kno}</td>
                                        <td className='thsmall'>{user.name}</td>
                                        <td className='thsmall'>{user.usertype}</td>
                                        <td className='thsmall'>{user.password}</td>
                                        <td><UilEditAlt onClick={() => { handleedit(user.kno, user.name, user.address, user.mobno, user.password, user.usertype, user.weight, user.fat, user.sanknew, user.sankedit, user.sankdelete, user.khsalenew, user.khsaleedit, user.khsaledelete, user.advnew, user.advedit, user.advdelete, user.ratibnew, user.ratibedit, user.ratibdelete, user.morningFrom, user.morningTo, user.eveningFrom, user.eveningTo, user.autosnf, user.mhsnf, user.gaysnf, user.summ, user.ekun, user.prevedit, user.centers) }} className="icsank" /><UilTrash className="icsank" /></td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                </div>

                <div className="containermobileuser">
                    <div className="row1mobile">
                        <div className="mobileverti">
                            <div className="settingsboxselected">
                                <img className='boximgmobileuser' src={milkcan} alt="" />
                                <span className='subheadmobileuser' style={fontStyle}>{t("mobileuser.permissions.sankalan")}</span>
                            </div>
                            <div className="line"></div>

                            <div className="row1mobile">
                                <div className="autobox">
                                    <span className='subheadmobileuser2' style={fontStyle}>{t("mobileuser.permissions.newSankalan")}</span>
                                    <label className="switch">
                                        <input type="checkbox" checked={sanknew === 'On'} onChange={handleTogglesanknew} />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                                <div className="autobox">
                                    <span className='subheadmobileuser2' style={fontStyle}>{t("mobileuser.permissions.editSankalan")}</span>
                                    <label className="switch">
                                        <input type="checkbox" checked={sankedit === 'On'} onChange={handleTogglesankedit} />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                                <div className="autobox">
                                    <span className='subheadmobileuser2' style={fontStyle}>{t("mobileuser.permissions.deleteSankalan")}</span>
                                    <label className="switch">
                                        <input type="checkbox" checked={sankdelete === 'On'} onChange={handleTogglesankdelete} />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                            </div>

                            <div className="line"></div>

                            <div className="settingsboxselected">
                                <img className='boximgmobileuser' src={khadya} alt="" />
                                <span className='subheadmobileuser' style={fontStyle}>{t("mobileuser.permissions.feedSale")}</span>
                            </div>

                            <div className="row1mobile">
                                <div className="autobox">
                                    <span className='subheadmobileuser2' style={fontStyle}>{t("mobileuser.permissions.newFeedSale")}</span>
                                    <label className="switch">
                                        <input type="checkbox" checked={khsalenew === 'On'} onChange={handleTogglekhsalenew} />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                                <div className="autobox">
                                    <span className='subheadmobileuser2' style={fontStyle}>{t("mobileuser.permissions.editFeedSale")}</span>
                                    <label className="switch">
                                        <input type="checkbox" checked={khsaleedit === 'On'} onChange={handleTogglekhsaleedit} />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                                <div className="autobox">
                                    <span className='subheadmobileuser2' style={fontStyle}>{t("mobileuser.permissions.deleteFeedSale")}</span>
                                    <label className="switch">
                                        <input type="checkbox" checked={khsaledelete === 'On'} onChange={handleTogglekhsaledelete} />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                            </div>

                            <div className="line"></div>

                            <div className="settingsboxselected">
                                <img className='boximgmobileuser' src={cash} alt="" />
                                <span className='subheadmobileuser' style={fontStyle}>{t("mobileuser.permissions.advance")}</span>
                            </div>

                            <div className="row1mobile">
                                <div className="autobox">
                                    <span className='subheadmobileuser2' style={fontStyle}>{t("mobileuser.permissions.newAdvance")}</span>
                                    <label className="switch">
                                        <input type="checkbox" checked={advnew === 'On'} onChange={handleToggleadvnew} />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                                <div className="autobox">
                                    <span className='subheadmobileuser2' style={fontStyle}>{t("mobileuser.permissions.editAdvance")}</span>
                                    <label className="switch">
                                        <input type="checkbox" checked={advedit === 'On'} onChange={handleToggleadvedit} />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                                <div className="autobox">
                                    <span className='subheadmobileuser2' style={fontStyle}>{t("mobileuser.permissions.deleteAdvance")}</span>
                                    <label className="switch">
                                        <input type="checkbox" checked={advdelete === 'On'} onChange={handleToggleadvdelete} />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                            </div>

                            <div className="line"></div>

                            <div className="settingsboxselected">
                                <img className='boximgmobileuser' src={farmer} alt="" />
                                <span className='subheadmobileuser' style={fontStyle}>{t("mobileuser.permissions.ratib")}</span>
                            </div>

                            <div className="row1mobile">
                                <div className="autobox">
                                    <span className='subheadmobileuser2' style={fontStyle}>{t("mobileuser.permissions.newRatib")}</span>
                                    <label className="switch">
                                        <input type="checkbox" checked={ratibnew === 'On'} onChange={handleToggleratibnew} />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                                <div className="autobox">
                                    <span className='subheadmobileuser2' style={fontStyle}>{t("mobileuser.permissions.editRatib")}</span>
                                    <label className="switch">
                                        <input type="checkbox" checked={ratibedit === 'On'} onChange={handleToggleratibedit} />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                                <div className="autobox">
                                    <span className='subheadmobileuser2' style={fontStyle}>{t("mobileuser.permissions.deleteRatib")}</span>
                                    <label className="switch">
                                        <input type="checkbox" checked={ratibdelete === 'On'} onChange={handleToggleratibdelete} />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                            </div>

                            <div className="line"></div>

                            <div className="settingsboxselected">
                                <img className='boximgmobileuser' src={weight} alt="" />
                                <span className='subheadmobileuser' style={fontStyle}>{t("mobileuser.sections.automation")}</span>
                            </div>

                            <div className="row1mobile">
                                <div className="autobox">
                                    <span className='subheadmobileuser2' style={fontStyle}>{t("mobileuser.labels.liter")}</span>
                                    <label className="switch">
                                        <input type="checkbox" checked={literauto === 'On'} onChange={handleToggle} />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                                <div className="autobox">
                                    <span className='subheadmobileuser2' style={fontStyle}>{t("mobileuser.labels.fat")}</span>
                                    <label className="switch">
                                        <input type="checkbox" checked={fatauto === 'On'} onChange={handleTogglefat} />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                            </div>

                            <div className="settingsboxselected">
                                <img className='boximgmobileuser' src={weight} alt="" />
                                <span className='subheadmobileuser' style={fontStyle}>{t("mobileuser.sections.totalSection")}</span>
                            </div>

                            <div className="row1mobile">
                                <div className="autobox">
                                    <span className='subheadmobileuser2' style={fontStyle}>{t("mobileuser.sections.totalSection")}</span>
                                    <label className="switch">
                                        <input type="checkbox" checked={ekun === 'On'} onChange={handleToggleekun} />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                            </div>

                            <div className="line"></div>

                            <div className="settingsboxselected">
                                <img className='boximgmobileuser' src={weight} alt="" />
                                <span className='subheadmobileuser' style={fontStyle}>{t("mobileuser.sections.oldEdit")}</span>
                            </div>

                            <div className="row1mobile">
                                <div className="autobox">
                                    <span className='subheadmobileuser2' style={fontStyle}>{t("mobileuser.sections.oldEdit")}</span>
                                    <label className="switch">
                                        <input type="checkbox" checked={prevedit === 'On'} onChange={handleToggleprev} />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                            </div>

                            <div className="settingsboxselected">
                                <img className='boximgmobileuser' src={weight} alt="" />
                                <span className='subheadmobileuser' style={fontStyle}>{t("mobileuser.sections.autoSnf")}</span>
                            </div>

                            <div className="row1mobile">
                                <div className="autobox">
                                    <span className='subheadmobileuser2' style={fontStyle}>{t("mobileuser.sections.autoSnf")}</span>
                                    <label className="switch">
                                        <input type="checkbox" checked={autosnf === 'On'} onChange={handleToggleautosnf} />
                                        <span className="slider round"></span>
                                    </label>

                                    <div className="rowmobileuser">
                                        <div className="autobox">
                                            <span className='subheadmobileuser2' style={fontStyle}>{t("mobileuser.labels.buffaloSnf")}</span>
                                            <div className="mb-2">
                                                <input disabled={autosnf === "Off"} type="text" autoComplete='off' id="mhsnf" name="mhsnf" value={input.mhsnf} onChange={handleChange} style={fontStyle}></input>
                                            </div>
                                        </div>
                                        <div className="autobox">
                                            <span className='subheadmobileuser2' style={fontStyle}>{t("mobileuser.labels.cowSnf")}</span>
                                            <div className="mb-2">
                                                <input disabled={autosnf === "Off"} type="text" autoComplete='off' id="gaysnf" name="gaysnf" value={input.gaysnf} onChange={handleChange} style={fontStyle}></input>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="settingsboxselected">
                                <img className='boximgmobileuser' src={time} alt="" />
                                <span className='subheadmobileuser' style={fontStyle}>{t("mobileuser.sections.shiftTime")}</span>
                            </div>

                            <div className="row1mobile3">
                                <div className="autoboxtime">
                                    <span className='subheadmobileuser2' style={fontStyle}>{t("mobileuser.labels.morningShift")}</span>
                                    <div className="row1mobile2">
                                        <input
                                            type="time"
                                            id='timefrom'
                                            value={morningFrom}
                                            onChange={handleTimeChange(setMorningFrom)}
                                        />
                                        <span className='subheadmobileuser2' style={fontStyle}>{t("mobileuser.common.to")}</span>
                                        <input
                                            type="time"
                                            id='timeto'
                                            value={morningTo}
                                            onChange={handleTimeChange(setMorningTo)}
                                        />
                                    </div>
                                </div>

                                <span className='subheadmobileuser2' style={fontStyle}>|</span>

                                <div className="autoboxtime">
                                    <span className='subheadmobileuser2' style={fontStyle}>{t("mobileuser.labels.eveningShift")}</span>
                                    <div className="row1mobile2">
                                        <input
                                            type="time"
                                            id='evntimefrom'
                                            value={eveningFrom}
                                            onChange={handleTimeChange(setEveningFrom)}
                                        />
                                        <span className='subheadmobileuser2' style={fontStyle}>{t("mobileuser.common.to")}</span>
                                        <input
                                            type="time"
                                            id='evntimeto'
                                            value={eveningTo}
                                            onChange={handleTimeChange(setEveningTo)}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="settingsboxselected">
                                <img className='boximgmobileuser' src={kendra} alt="" />
                                <span className='subheadmobileuser' style={fontStyle}>{t("mobileuser.sections.selectCenter")}</span>
                            </div>

                            <div className="row1mobile3">
                                <div className="checkbox-container">
                                    {DataSourcekendra.map(item => (
                                        <div key={item.sr} className="checkbox-item">
                                            <span className="subheadmobileuser2" style={fontStyle}>{item.city.trim()}</span>
                                            <label className="switch">
                                                <input
                                                    type="checkbox"
                                                    checked={selectedCenters.some(obj => obj.center === item.city.trim())}
                                                    onChange={() => handleTogglekendra(item.city, item.sr)}
                                                />
                                                <span className="slider round"></span>
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div>
    )
}

export default Mobileuser